import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ProgressBar from '../ProgressBar'
import styles from './styles.scss'
import { parseTitle, parseContent } from '../../../../markdown/parser'

class Toast extends Component {
    constructor(props) {
        super(props)

        this.elapsedTimer = undefined
        this.state = {
            elapsed: 0,
            start: new Date(),
        }

        this.timeout = 0
    }

    componentDidMount() {
        this.setTimeout()
        // Start the timer...
        if (this.timeout > 0) {
            this.elapsedTimer = setInterval(this.tick, 50)
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.hidden !== this.props.hidden) {
            if (this.props.hidden) {
                // hiding
                this.pause()
            } else {
                // showing
                this.resume()
            }
        }
        if (prevProps.timeout !== this.props.timeout) {
            this.setTimeout()
        }

        // We have received the same toast again, reset the timer...
        if (prevProps.counts.sinceLast !== this.props.counts.sinceLast) {
            this.reset()
        }
    }

    componentWillUnmount() {
        // cancel timers
        clearInterval(this.elapsedTimer)
    }

    setTimeout() {
        const { isMessage, timeout } = this.props
        if (isMessage) {
            this.timeout = 0
        } else if (typeof timeout === 'boolean') {
            this.timeout = timeout ? 5000 : 0
        } else {
            this.timeout = timeout < 1 ? 0 : timeout
        }
    }

    getClassNames = () => {
        const { isMessage, type } = this.props

        const classNames = styles('container', {
            motd: isMessage,
            toast: !isMessage,
            info: isMessage || type === 'info',
            warning: !isMessage && type === 'warning',
            error: !isMessage && type === 'error',
            success: !isMessage && type === 'success',
        })

        return classNames
    }

    reset = () => {
        if (this.timeout > 0) {
            this.setState({ elapsed: 0 })
        }
    }

    pause = () => {
        if (this.timeout > 0) {
            clearInterval(this.elapsedTimer)
        }
    }

    resume = () => {
        if (this.timeout > 0) {
            this.elapsedTimer = setInterval(this.tick, 50)
        }
    }

    mouseEnter = () => {
        this.pause()
    }

    mouseLeave = () => {
        this.resume()
    }

    tick = () => {
        const elapsed = this.state.elapsed + 50 // new Date() - this.state.start
        this.setState({ elapsed })
        if (elapsed >= this.timeout) {
            clearInterval(this.elapsedTimer)
            this.dismiss()
        }
    }

    dismiss = () => {
        if (!this.props.showCloseButton) {
            this.props.onDismissClick()
        }

        if (this.props.dismissOnClick) {
            this.props.onDismissClick()
        }
    }

    renderCloseButton = () => {
        if (!this.props.showCloseButton) {
            return null
        }

        const { isMessage } = this.props
        const classNames = styles('dismiss', {
            toast: !isMessage,
            motd: isMessage,
        })

        const props = {
            className: classNames,
            onClick: this.props.onDismissClick,
        }

        return <button {...props}>×</button>
    }

    renderProgressBar = () => {
        if (this.timeout < 1 || !this.props.timeoutBar) return null

        return (
            <div
                style={{
                    width: '100%',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: '2px',
                }}
            >
                <ProgressBar percent={100 * (this.state.elapsed / this.timeout)} />
            </div>
        )
    }

    renderTitle = () => {
        if (this.props.title == null) return null
        const { isMessage } = this.props
        const classNames = styles('title', {
            toast: !isMessage,
            motd: isMessage,
        })

        const title = isMessage ? parseTitle(this.props.title) : this.props.title
        return <div className={classNames}>{title}</div>
    }

    renderContent = () => {
        const { isMessage } = this.props
        const classNames = styles('content', {
            toast: !isMessage,
            motd: isMessage,
        })

        const content = isMessage
            ? parseContent(this.props.content, this.props.updated, this.props.locale)
            : this.props.content
        return <div className={classNames}>{content}</div>
    }

    renderCount = () => {
        const { counts, showCounter } = this.props
        if (!showCounter || counts.sinceLast < 2) return null
        return (
            <div>
                {counts.total}/{counts.sinceLast}
            </div>
        )
    }

    render() {
        if (this.props.hidden) return null

        const closeButton = this.renderCloseButton()
        const progressBar = this.renderProgressBar()
        const title = this.renderTitle()
        const content = this.renderContent()
        const count = this.renderCount()

        const settings = {
            role: 'presentation',
            onClick: this.dismiss,
            onMouseEnter: this.mouseEnter,
            onMouseLeave: this.mouseLeave,
            className: this.getClassNames(),
        }

        return (
            <li {...settings}>
                {title}
                {content}
                {closeButton}
                {progressBar}
                {count}
            </li>
        )
    }
}

Toast.propTypes = {
    onDismissClick: PropTypes.func.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    isMessage: PropTypes.bool.isRequired,
    showCloseButton: PropTypes.bool,
    dismissOnClick: PropTypes.bool,
    timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    timeoutBar: PropTypes.bool,
    hidden: PropTypes.bool,
    type: PropTypes.oneOf(['info', 'warning', 'error', 'success']),
    counts: PropTypes.shape({
        total: PropTypes.number,
        sinceLast: PropTypes.number,
    }),
    showCounter: PropTypes.bool,
    updated: PropTypes.string,
    locale: PropTypes.string,
}

Toast.defaultProps = {
    showCloseButton: true,
    dismissOnClick: true,
    timeout: false,
    hidden: false,
    isMessage: false,
    type: 'success',
}

export default Toast



// WEBPACK FOOTER //
// ./src/features/Toaster/components/Toaster/components/Toast/index.js